import LogoAndFavicon from './LogoAndFavicon';

export default LogoAndFavicon;
